import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";

export interface ShopRedirectApi {
  id: number;
  shopId: number;
  sourcePath: string;
  destinationPath: string;
  isPermanent: boolean;
  isPattern: boolean;
  description?: string;
}

export interface CreateShopRedirectRequest {
  sourcePath: string;
  destinationPath: string;
  isPermanent: boolean;
  isPattern: boolean;
  description?: string;
}

export interface UpdateShopRedirectRequest {
  sourcePath: string;
  destinationPath: string;
  isPermanent: boolean;
  isPattern: boolean;
  description?: string;
}

export interface ShopRedirectChainStep {
  redirectId: number;
  sourcePath: string;
  destinationPath: string;
  isPermanent: boolean;
}

export interface ShopRedirectChain {
  steps: ShopRedirectChainStep[];
  finalDestination: string;
  isCircular: boolean;
}

export interface FlattenRedirectChainsResponse {
  flattenedRedirectsCount: number;
  skippedCircularCount: number;
}

const fetch = (): AxiosPromise<ShopRedirectApi[]> =>
  api.get<ShopRedirectApi[]>(endpoints.SHOP.REDIRECTS.GET());

const create = (data: CreateShopRedirectRequest): AxiosPromise<void> =>
  api.post(endpoints.SHOP.REDIRECTS.CREATE(), data);

const update = (id: number, data: UpdateShopRedirectRequest): AxiosPromise<void> =>
  api.put(endpoints.SHOP.REDIRECTS.UPDATE(id), data);

const deleteRedirect = (id: number): Promise<void> =>
  api.delete(endpoints.SHOP.REDIRECTS.DELETE(id));

const fetchChains = (): AxiosPromise<ShopRedirectChain[]> =>
  api.get<ShopRedirectChain[]>(endpoints.SHOP.REDIRECTS.CHAINS());

const flatten = (chainStartIds?: number[]): AxiosPromise<FlattenRedirectChainsResponse> =>
  api.post(endpoints.SHOP.REDIRECTS.FLATTEN(), { chainStartIds: chainStartIds ?? null });

export const shopRedirectsApi = {
  fetch,
  create,
  update,
  delete: deleteRedirect,
  fetchChains,
  flatten,
};
